module.exports = __webpack_public_path__ + "static/media/plus.ce93a1ae.svg";